















































import { Vue, Component, Watch } from 'vue-property-decorator'
import { fetchEarnList } from '@/api/portfolio'
import { calcEarnTest } from '@/api/card/investCard'
import { CommonMudule } from '@/store/modules/common'
import DialogSlot from '@/components/dialog/doalogSlot.vue'
import FormItem from '@/components/formItem/index.vue'
import TsForm from '@/components/TsForm/index.vue'

@Component({
  components: {
    DialogSlot,
    TsForm,
    FormItem,
  },
})
export default class extends Vue {
  dialogShow = false
  value = 0
  addNum = 0
  marks = {
    0: 'R1-保守型',
    1: 'R2-相对保守型',
    2: 'R3-稳健型',
    3: 'R4-相对积极型',
    4: 'R5-积极型'
  }

  markInfo = {}

  data: { title: string; name: string }[] = [];

  @Watch('value', { immediate: true, deep: true })
  watchValue (v: number) {
    if (v || v === 0) {
      for (const key in this.riskTypeObj) {
        if (this.riskTypeObj[key].value === v) {
          this.addNum = this.riskTypeObj[key].addNum
        }
      }
    }
  }

  formatTooltip (v: string) {
    console.log('vv', v)
    for (const key in this.riskTypeObj) {
      if (this.riskTypeObj[key].value === v) {
        return this.riskTypeObj[key].num
      }
    }
  }

  riskTypeObj = {
    Conservative: {
      name: 'R1-保守型',
      value: 0,
      num: 0,
      addNum: 0
    },
    ConservativeModerately: {
      name: 'R2-相对保守型',
      value: 1,
      num: 0,
      addNum: 0
    },
    Steady: {
      name: 'R3-稳健型',
      value: 2,
      num: 0,
      addNum: 0
    },
    PositiveModerately: {
      name: 'R4-相对积极型',
      value: 3,
      num: 0,
      addNum: 0
    },
    Positive: {
      name: 'R5-积极型',
      value: 4,
      num: 0,
      addNum: 0
    }
  }

  fetchApi () {
    this.onFetchEarnList()
    this.onCalcEarnTest()
  }

  private async onFetchEarnList () {
    const res = await fetchEarnList()
    if (res.statusCode === 0 && res.data) {
      res.data.forEach((item: {annualRateOfReturn: string; riskType: string}) => {
        this.riskTypeObj[item.riskType].num = item.annualRateOfReturn + '%'
      })
    }
  }

  async onCalcEarnTest () {
    const res = await calcEarnTest({
      customerId: CommonMudule.customerId,
      years: '22'
    })
    if (res.statusCode === 0 && res.data) {
      for (const key in res.data) {
        this.riskTypeObj[key].addNum = res.data[key]
      }
      this.value = 2
    }
  }

  handleConfirm () {
    this.dialogShow = false
  }

  show () {
    this.dialogShow = true
    this.fetchApi()
  }

  handleClose () {
    this.dialogShow = false
  }
}
